import { gql } from "@apollo/client";

export const UPDATE_PRODUCT_MUTATION = gql`
  mutation UpdateProduct(
    $productID: ID!
    $vat: Boolean
    $vatPercent: Int32
    $vatValue: Int64
    $note: String
    $prices: ProductPriceInput
    $productDiscounts: [ProductDiscountInput!]
    $sellingStatus: SellingStatus
    $vatType: VatType = OPTIONAL
    $minOrderQuantity: Int64
    $fulfillmentMode: ProductFulfillmentMode = IN_STOCK
    $preOrderPolicy: ProductPreOrderPolicyInput
    $productWarrantyPriceInput: [ProductWarrantyPriceInput!]
    $productPreOrderPolicy: [PreOrderPolicyInput!]
    $canPreOrder: Boolean
  ) {
    product {
      setPrices(
        id: $productID
        prices: $prices
        vat: $vat
        vatPercent: $vatPercent
        vatValue: $vatValue
        productDiscounts: $productDiscounts
        note: $note
        sellingStatus: $sellingStatus
        vatType: $vatType
        minOrderQuantity: $minOrderQuantity
        preOrderPolicy: $preOrderPolicy
        fulfillmentMode: $fulfillmentMode
        productWarrantyPrice: $productWarrantyPriceInput
        productPreOrderPolicy: $productPreOrderPolicy
        canPreOrder: $canPreOrder
      ) {
        id
      }
    }
  }
`;

export const UPDATE_PRODUCT_STATUS = gql`
  mutation UpdateProductStatus($ids: [ID!], $sellingStatus: SellingStatus) {
    product {
      updateStatus(ids: $ids, sellingStatus: $sellingStatus) {
        id
        isActive
      }
    }
  }
`;

export const CREATE_PRODUCT_GROUP_MUTATION = gql`
  mutation CreateProductGroup($req: ProductGroupInput!) {
    productGroup {
      create(req: $req) {
        id
        products {
          id
        }
        code
      }
    }
  }
`;

export const UPDATE_PRODUCT_GROUP_MUTATION = gql`
  mutation UpdateProductGroup($id: ID!, $req: ProductGroupInput!) {
    productGroup {
      update(id: $id, req: $req) {
        id
        products {
          id
        }
      }
    }
  }
`;

export const UPLOAD_FILE_PRODUCT_PRICE_LOGS_MUTATION = gql`
  mutation UploadFileProductPriceLogs($file: Upload!) {
    product {
      importProductPrices(file: $file) {
        id
        status
        errorFileURL
        errorReason
        updated_count
      }
    }
  }
`;

export const CREATE_PRODUCT_BRAND = gql`
  mutation CreateProductBrand($request: CreateBrandInput) {
    brand {
      create(request: $request)
    }
  }
`;

export const UPDATED_PRODUCT_BRAND = gql`
  mutation UpdateProductBrand($request: UpdateBrandInput) {
    brand {
      update(request: $request)
    }
  }
`;

export const CREATE_QUOTATION_SESSION = gql`
  mutation CreateQuotationSession(
    $items: [QuotationItemInput!]!
    $quota: Int64
    $quotationSessionType: QuotationSessionType = FIXED_PRICE
  ) {
    product {
      createQuotationSession(items: $items, quota: $quota, quotationSessionType: $quotationSessionType) {
        id
        expirationTime
        quota
        type
      }
    }
  }
`;

// Ghi đè toàn bộ tập kênh bán của SP (saleChannelIDs được phép rỗng).
// Response trả id + saleChannels để Apollo tự cập nhật cache của GET_PRODUCT_QUERY.
export const SET_PRODUCT_SALE_CHANNELS = gql`
  mutation SetProductSaleChannels($id: ID!, $saleChannelIDs: [ID!]!) {
    product {
      setSaleChannels(id: $id, saleChannelIDs: $saleChannelIDs) {
        id
        saleChannels {
          id
          name
          type
          platformID
        }
      }
    }
  }
`;

export const UPDATE_PRODUCT_SOLD_DISPLAY_MODE = gql`
  mutation UpdateProductSoldDisplayMode($product_id: ID!, $display_mode: ProductSoldDisplayMode!) {
    updateProductSoldDisplayMode(product_id: $product_id, display_mode: $display_mode) {
      product_id
      product_code
      actual_sold_count
      extra_sold_count
      display_mode
    }
  }
`;
export const UPDATE_PRODUCT_EXTRA_SOLD_COUNT = gql`
  mutation UpdateProductExtraSoldCount($product_id: ID!, $extra_sold_count: Int!) {
    updateProductExtraSoldCount(product_id: $product_id, extra_sold_count: $extra_sold_count) {
      product_id
      product_code
      actual_sold_count
      extra_sold_count
      display_mode
    }
  }
`;
